<template>
  <v-dialog v-model="dialog.show" max-width="520" persistent>
    <v-card>
      <v-card-title>{{ $t("settings.profile.emailAccounts.dialog.sendTest.title") }}</v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <v-text-field
          v-model="dialog.to"
          :label="$t('settings.profile.emailAccounts.dialog.sendTest.to')"
          :placeholder="$t('settings.profile.emailAccounts.dialog.sendTest.toPlaceholder')"
          autocomplete="off"
        />
        <v-alert v-if="dialog.error" type="error" class="mt-2">
          {{ dialog.error }}
        </v-alert>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" :disabled="dialog.sending" @click="$emit('close')">
          {{ $t("settings.profile.emailAccounts.dialog.actions.cancel") }}
        </v-btn>
        <v-btn color="primary" :loading="dialog.sending" @click="$emit('send')">
          {{ $t("settings.profile.emailAccounts.dialog.actions.send") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "UserEmailAccountSendTestDialog",
  props: {
    dialog: {
      type: Object,
      required: true,
    },
  },
  emits: ["close", "send"],
};
</script>
